import { Box, CircularProgress } from '@mui/material';

const spinnerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%'
};

const Spinner = () => {
  return (
    <Box sx={spinnerStyle}>
      <CircularProgress />
    </Box>
  );
};

export default Spinner;
